import { render, staticRenderFns } from "./Pf-Terminal-Statistics.vue?vue&type=template&id=116d2928"
import script from "./Pf-Terminal-Statistics.vue?vue&type=script&lang=js"
export * from "./Pf-Terminal-Statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports